/* tslint:disable */
/* eslint-disable */
/**
 * Pet Profile A Service
 * Pet Profile A Layer Service For more information or information on how this data maps to the kryios data see [here](https://chewyinc.atlassian.net/wiki/spaces/MPROD/pages/1957927091/Pet+Property+to+Data+Mapping)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: DL-IT_Pet_Profile@chewy.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { FormButtonEventModel } from './FormButtonEventModel';
import {
    FormButtonEventModelFromJSON,
    FormButtonEventModelFromJSONTyped,
    FormButtonEventModelToJSON,
} from './FormButtonEventModel';
import type { FormButtonOnSaveModel } from './FormButtonOnSaveModel';
import {
    FormButtonOnSaveModelFromJSON,
    FormButtonOnSaveModelFromJSONTyped,
    FormButtonOnSaveModelToJSON,
} from './FormButtonOnSaveModel';

/**
 * 
 * @export
 * @interface FormButtonModel
 */
export interface FormButtonModel {
    /**
     * 
     * @type {string}
     * @memberof FormButtonModel
     */
    label: string;
    /**
     * 
     * @type {string}
     * @memberof FormButtonModel
     */
    type: FormButtonModelTypeEnum;
    /**
     * 
     * @type {FormButtonOnSaveModel}
     * @memberof FormButtonModel
     */
    onSave?: FormButtonOnSaveModel;
    /**
     * 
     * @type {FormButtonEventModel}
     * @memberof FormButtonModel
     */
    event: FormButtonEventModel;
}


/**
 * @export
 */
export const FormButtonModelTypeEnum = {
    Primary: 'PRIMARY',
    Secondary: 'SECONDARY'
} as const;
export type FormButtonModelTypeEnum = typeof FormButtonModelTypeEnum[keyof typeof FormButtonModelTypeEnum];


/**
 * Check if a given object implements the FormButtonModel interface.
 */
export function instanceOfFormButtonModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "label" in value;
    isInstance = isInstance && "type" in value;
    isInstance = isInstance && "event" in value;

    return isInstance;
}

export function FormButtonModelFromJSON(json: any): FormButtonModel {
    return FormButtonModelFromJSONTyped(json, false);
}

export function FormButtonModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FormButtonModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': json['label'],
        'type': json['type'],
        'onSave': !exists(json, 'onSave') ? undefined : FormButtonOnSaveModelFromJSON(json['onSave']),
        'event': FormButtonEventModelFromJSON(json['event']),
    };
}

export function FormButtonModelToJSON(value?: FormButtonModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': value.label,
        'type': value.type,
        'onSave': FormButtonOnSaveModelToJSON(value.onSave),
        'event': FormButtonEventModelToJSON(value.event),
    };
}

